export const environmentConfig = {
    dev: {
        internal: {
            regionlessHostUrl: "https://pw2-portfoliowatch-webservice.ecswai.rett.c1.vanguard.com",
            phcRegionlessHostUrl: "https://pw3-portfolio-health-check-api.ecswai.rett.c1.vanguard.com",
            regionlessEcsUrl: "https://apii.ecs.us-east-1.rett.c1.vanguard.com",
            angularEnv: "development"
        },
        external: {
            regionlessHostUrl: "https://satpersonal1.vanguard.com",
            phcRegionlessHostUrl: "https://satpersonal1.vanguard.com",
            regionlessEcsUrl: "https://satpersonal1.vanguard.com",
            angularEnv: "development"
        }
    },
    test: {
        internal: {
            regionlessHostUrl: "https://pw2-portfoliowatch-webservice.ecswai.rett.c1.vanguard.com",
            phcRegionlessHostUrl: "https://pw3-portfolio-health-check-api.ecswai.rett.c1.vanguard.com",
            regionlessEcsUrl: "https://apii.ecs.us-east-1.rett.c1.vanguard.com",
            angularEnv: "non-production"
        },
        external: {
            regionlessHostUrl: "https://satpersonal1.vanguard.com",
            phcRegionlessHostUrl: "https://satpersonal1.vanguard.com",
            regionlessEcsUrl: "https://satpersonal1.vanguard.com",
            angularEnv: "non-production"
        }
    },
    eng: {
        internal: {
            regionlessHostUrl: "https://pw2-portfoliowatch-webservice.ecswai.rete.c1.vanguard.com",
            phcRegionlessHostUrl: "https://pw3-portfolio-health-check-api.ecswai.rete.c1.vanguard.com",
            regionlessEcsUrl: "https://prfapii.ecs.us-east-1.rett.c1.vanguard.com",
            angularEnv: "eng"
        },
        external: {
            regionlessHostUrl: "https://devpersonal1.vanguard.com",
            phcRegionlessHostUrl: "https://devpersonal1.vanguard.com",
            regionlessEcsUrl: "https://prfapps.ecs.rett.c1.vanguard.com",
            angularEnv: "eng"
        }
    },
    prod: {
        internal: {
            regionlessHostUrl: "https://pw2-portfoliowatch-webservice.ecswai.retp.c1.vanguard.com",
            phcRegionlessHostUrl: "https://pw3-portfolio-health-check-api.ecswai.retp.c1.vanguard.com",
            regionlessEcsUrl: "https://apii.ecs.us-east-1.retp.c1.vanguard.com",
            angularEnv: "production"
        },
        external: {
            regionlessHostUrl: "https://personal1.vanguard.com",
            phcRegionlessHostUrl: "https://personal1.vanguard.com",
            regionlessEcsUrl: "https://personal1.vanguard.com",
            angularEnv: "production"
        }
    }
} as const;